import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'OrderbyPipe'
})
export class OrderbyPipe implements PipeTransform {

  transform(array: Array<string>, args: string): Array<string> {

    if(!array || array === undefined || array.length === 0) return null;
  
      array.sort((a: any, b: any) => {
        if (new Date(a.lastViewedByMeDate) < new Date(b.lastViewedByMeDate)) {
          return 1;
        } else if (new Date(a.lastViewedByMeDate )>new Date(b.lastViewedByMeDate) ) {
          return -1;
        } else {
          return 0;
        }
      });
      return array;
    }
  
  }



// WEBPACK FOOTER //
// ./src/app/shelf/Orderby.pipe.ts